import { vservice } from '@niknevis/vue-modules'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { AdminContentItemService } from '@/modules/content-item/services/admin-content-item.service'

@vservice()
export class AdminContentItemManualDiscountUseCase implements BaseRequestLoadingHandler {
  constructor(
    private readonly service: AdminContentItemService
  ) {
  }

  isSuccess = false

  isLoading = false

  execute(contentItemId: number, manualDiscount: number) {
    return this.service
      .updateContentItemManualDiscount(contentItemId, { manual_discount: manualDiscount })
      .onStart(() => {
        this.isLoading = true
        this.isSuccess = false
      })
      .onFinish(() => {
        this.isLoading = false
      })
      .onSuccess(() => {
        this.isSuccess = true
      })
  }
}